import React from "react";
import { Trans } from "@payping/utils/localeUtils";
import { Col, Row, Typography } from "@payping/web-components";
import classnames from "classnames";
import { Link } from "react-router-dom";
import { webConstants } from "@payping/utils/platformConstants";
import { ShaparakWizardStatusEnum } from "@payping/api";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { useAppSelector } from "@/utils/redux";
import {
  oldUserProfileId,
  oldUserProfileRejectId,
  oldUserProfileSuccess,
} from "@/assets/googleTrackIds";
import StatusIcon from "./statusIcon";
import { FrontShaparakWizardStatusEnum, WizardBoxType } from "./types";
import wizardStyle from "../../../assets/scss/Wizard.module.scss";
import { translationKeys } from "./constants";

const { Text } = Typography;

const WizardBox: React.FC<WizardBoxType> = (props: WizardBoxType) => {
  const { t } = useAppTranslation();
  const { DashboardRoutes, HELP_URL } = webConstants;
  const personalInfo = useAppSelector((state) => state.user.personalInfo);

  const getUrl = () => {
    switch (props.description) {
      case translationKeys.desc.userPending:
        return <Link data-google-track={oldUserProfileId} to={DashboardRoutes.user.profile.root}></Link>;
      case translationKeys.desc.dataRejected:
        return <Link data-google-track={oldUserProfileRejectId} to={DashboardRoutes.user.profile.root}></Link>;
      case translationKeys.desc.terminalSuccess:
        return <a data-google-track={oldUserProfileSuccess} target="_blank" rel="noreferrer" href={HELP_URL}></a>;
      default:
        return <></>;
    }
  };

  const titleColor = () => {
    if (props.step === 2) {
      if (
        props.status === ShaparakWizardStatusEnum.ShaparakRejected ||
        props.status === ShaparakWizardStatusEnum.AdminRejected
      )
        return "color--danger";
      if (props.status === ShaparakWizardStatusEnum.Success || props.status === FrontShaparakWizardStatusEnum.Default)
        return "";
      return "color--cta";
    }
    return "";
  };

  return (
    <Row justify="start" align="middle" className={classnames(wizardStyle.wizardTextWrapper, "h-100 m-auto")}>
      <Col className={classnames(wizardStyle.marginTopMd)}>
        <div className="text-center mb-1">
          <span className={classnames(wizardStyle.wizardSteps, "font-weight-bold")}>
            {t(`overview.wizard.${props.step}step`)}
          </span>
        </div>
        <div> {props?.icon && <StatusIcon status={props.icon} />}</div>
      </Col>
      <Col className={classnames(wizardStyle.wizardTextMaxWidth, "mr-1 mt-1")}>
        <Text strong className={titleColor()}>
          {t(`overview.wizard.${props.title}`)}
        </Text>
        <br />
        {props?.isLastStep && props?.description && (
          <Trans
            i18nKey={`Wrapper:overview.wizard.${props.description}`}
            values={{ firstName: personalInfo?.firstName, reason: props?.reason }}
            components={[getUrl()]}
          />
        )}
      </Col>
    </Row>
  );
};

export default WizardBox;
